import React from "react";
import "./pickup_highcage.css";

/**
 * 🟦 PickupHighcageDetails.jsx
 * แสดงรายละเอียดเบี้ยประกันภัยคอกสูง 2+ / 3+/Users/apichet/Downloads/cheetah-insurance-app/frontend/src/packages/viriyah/motor/viriyah_pickup_highcage_2p3p/PickupHighcageDetails.jsx
 * สำหรับรถปิกอัพ ≤ 4 ตัน (Single Rate)
 */

export default function PickupHighcageDetails({ onQuote }) {
  const rows = [
    { fund: "100,000", type2p: "8,377", type3p: "7,353" },
    { fund: "200,000", type2p: "11,076", type3p: "8,563" },
    { fund: "300,000", type2p: "12,193", type3p: "9,866" },
    { fund: "400,000", type2p: "13,403", type3p: "11,076" },
    { fund: "500,000", type2p: "14,613", type3p: "12,286" },
  ];

  return (
    <div className="pkg-detail pickup-highcage">
      <h2>คอกสูง 2+ / 3+ (Single Rate)</h2>
      <p>รับรถปิกอัพ คอกเหล็ก คอกไม้ หรือตู้บรรทุก ≤ 4 ตัน</p>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>ทุนประกันภัย</th>
            <th>2+ เบี้ยรวม (บาท)</th>
            <th>3+ เบี้ยรวม (บาท)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.fund}>
              <td>{r.fund}</td>
              <td>{r.type2p}</td>
              <td>{r.type3p}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>* รวม CCTV Discount และ App แจ้งเหตุแล้ว</p>
        <button className="pkg-quote-btn" onClick={onQuote}>
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
